import React, {memo} from 'react';
import {Bar} from 'react-chartjs-2';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles, useTheme} from '@material-ui/styles';
import {
    Card,
    CardHeader,
    CardContent,
    Divider,
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
    root: {
        height: '100%',
        maxHeight: '310px',
    },
    cardContent: {
        height: '100%',
    },
    chartContainer: {
        position: 'relative',
        height: '100%',
    },
}));

const BarChart = memo(props => {
    const {className, term, data, ...rest} = props;
    const classes = useStyles(props);
    const theme = useTheme();
    const termLabel = {
        'daily': 'Daily',
        'weekly': 'Weekly',
        'monthly': 'Monthly',
    };

    if (!data) return null;

    const barChartData = (data) => {
        return {
            labels: data.map(cate => cate.label),
            datasets: [
                {
                    barThickness: 20,
                    backgroundColor: theme.palette.primary.main,
                    data: data.map(cate => cate.point),
                },
            ],
        };
    };
    const chartOptions = {
        title: {
            display: false,
            text: `${termLabel[term]} Category Revenue: ${data.total.toLocaleString()}Point`,
        },
        legend: false,
        tooltips: {
            mode: 'nearest',
            intersect: false,
        },
        responsive: false,
        cornerRadius: 0,
        layout: {padding: 0},
        scales: {
            xAxes: [
                {
                    ticks: {
                        fontColor: theme.palette.text.secondary,
                    },
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                },
            ],
            yAxes: [
                {
                    ticks: {
                        fontColor: theme.palette.text.secondary,
                        beginAtZero: true,
                    },
                    gridLines: {
                        borderDash: [2],
                        borderDashOffset: [2],
                        color: theme.palette.divider,
                        drawBorder: false,
                        zeroLineColor: theme.palette.divider,
                    },
                },
            ],
        },
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardHeader
                title={`${termLabel[term]} Category Revenue: ${data.total.toLocaleString()}Point`}
            />
            <Divider/>
            <CardContent className={classes.cardContent}>
                <div className={classes.chartContainer}>
                    <Bar
                        data={barChartData(data.data)}
                        height={230}
                        options={chartOptions}
                    />
                </div>
            </CardContent>
        </Card>
    );
});

BarChart.propTypes = {
    className: PropTypes.string,
    term: PropTypes.string,
    data: PropTypes.any,
};

export default BarChart;
